export const STATE_OPTIONS = [
  { key: "posted", label: "Posted" },
  { key: "scheduled", label: "Scheduled" },
  { key: "unposted", label: "Unposted" },
  { key: "quarantined", label: "Quarantined" },
  { key: "cancelled", label: "Cancelled" },
  { key: "pending", label: "Pending" },
  { key: "settled", label: "Settled" },
  { key: "refunded", label: "Refunded" },
  { key: "failed", label: "Failed" },
  { key: "voided", label: "Voided" },
];

export function getLineStateKey(line = {}) {
  if (line.state) return String(line.state).toLowerCase();
  if (line.is_voided) return "voided";
  if (line.source_status === "pending") return "pending";
  if (
    line.recognition_status === "scheduled" ||
    line.recognition_status === "future"
  ) {
    return "scheduled";
  }
  if (line.recognition_status === "unposted") return "unposted";
  return "posted";
}

export function getLineStateMeta(line) {
  const state = getLineStateKey(line);
  const states = {
    voided: { label: "Voided", className: "rav-statePill--voided" },
    pending: { label: "Pending", className: "rav-statePill--pending" },
    scheduled: { label: "Scheduled", className: "rav-statePill--scheduled" },
    unposted: { label: "Unposted", className: "rav-statePill--unposted" },
    settled: { label: "Settled", className: "rav-statePill--settled" },
    refunded: { label: "Refunded", className: "rav-statePill--refunded" },
    failed: { label: "Failed", className: "rav-statePill--failed" },
    quarantined: {
      label: "Quarantined",
      className: "rav-statePill--quarantined",
    },
    cancelled: {
      label: "Cancelled",
      className: "rav-statePill--cancelled",
    },
    posted: { label: "Posted", className: "rav-statePill--posted" },
  };
  return states[state] || states.posted;
}

export function calculateQuarantinedCharges(lines) {
  return (lines || []).reduce((total, line) => {
    if (getLineStateKey(line) !== "quarantined") return total;
    const amount = Number(line?.amount);
    return total + (Number.isFinite(amount) ? Math.abs(amount) : 0);
  }, 0);
}

